import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { IAppState } from '../../../../models/reduxState';
import { isDarkThemeSelector, sourceAppSelector } from '../../../app/selectors/contactUsSelector';
import { UserDescriptionField } from '../../presentationalComponents/RequestDetails/UserDescriptionField';
import { dispatchUpdateRequest } from '../../reduxUpdater/dispatchers/requestDispatchers';
import { isUserDescriptionFieldDisabledSelector } from '../../reduxUpdater/selectors/commonSelectors';
import { userDescriptionSelector } from '../../reduxUpdater/selectors/requestSelector';
import { getRequestDetailsStyles } from '../../styles/requestDetailsStyles';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
  return {
    isUserDescriptionFieldDisabled: isUserDescriptionFieldDisabledSelector(state),
    sourceApp: sourceAppSelector(state),
    isDarkTheme: isDarkThemeSelector(state),
    userDescription: userDescriptionSelector(state),
  };
};

const mapDispatchToProps = {
  dispatchUpdateRequest,
};

export const UserDescriptionFieldContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(UserDescriptionField, getRequestDetailsStyles));
